import styled from '@emotion/styled'
import { spacing } from 'main/ui'

export const FieldsFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const TooltipIconContainer = styled.div`
  display: inline-block;
  cursor: pointer;
  height: 17px;
  margin-left: ${spacing.majorScale(1)}px;
  vertical-align: middle;
  width: 17px;
`

export const ChecksContainer = styled.div`
  height: 95px;
  margin: ${spacing.majorScale(1)}px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`
